import type { PerPageInputOption } from './type'

import i18n from '@/lib/i18n'

export const options: PerPageInputOption[] = [
  {
    label: `30 ${i18n.t('order.history.label.units')}`,
    value: 30,
  },
  {
    label: `50 ${i18n.t('order.history.label.units')}`,
    value: 50,
  },
  {
    label: `100 ${i18n.t('order.history.label.units')}`,
    value: 100,
  },
]

export const DEFAULT_PER_PAGE = options[0].value
